import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_COMPANY_LOCATIONS_QUERY } from "../../graphql/Company/CompanyLocations.graphql";

function CompanyLocationSelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  required,
  readOnly,
  firstOptionEnabled = false
}) {
  const { data, loading, error } = useQuery(ALL_COMPANY_LOCATIONS_QUERY, {
    variables
  });

  useEffect(() => {
    if (
      !firstOptionEnabled &&
      data &&
      !loading &&
      Array.isArray(data.CompanyLocations) &&
      data.CompanyLocations.length > 0 &&
      !value
    ) {
      onChange({
        target: {
          name,
          value: data.CompanyLocations[0].RecId
        }
      });
    }
  }, [data, loading, name, onChange, value, firstOptionEnabled]);

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : "secondary"
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            {firstOptionEnabled && (
              <Select.Option value={0}>Select...</Select.Option>
            )}
            {!loading &&
              data &&
              data.CompanyLocations.map(companyLocation => (
                <Select.Option
                  key={companyLocation.RecId}
                  value={companyLocation.RecId}
                >
                  {companyLocation.Name}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

CompanyLocationSelect.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  firstOptionEnabled: PropTypes.bool
};

CompanyLocationSelect.defaultProps = {
  variables: { where: { Active: true } }
};
export default CompanyLocationSelect;
